var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 31,
    viewBox: "0 0 106 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-568 -522)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 106,
    height: 31,
    rx: 5,
    transform: "translate(568 522)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Email",
    transform: "translate(635 542)",
    fill: "#e0611a",
    fontSize: 12,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17,
    y: 0
  }, "Email")), /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(590 529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M155.66,353.856v12.08a2.006,2.006,0,0,1-2,2h-16a2,2,0,0,1-2-2v-12a1.853,1.853,0,0,1,.12-.67l9.79,8.32Z",
    transform: "translate(-135.66 -351.936)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M155.66,353.856l-10.09,7.73-9.79-8.32a1.982,1.982,0,0,1,1.88-1.33h16A2,2,0,0,1,155.66,353.856Z",
    transform: "translate(-135.66 -351.936)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBtn);
export default __webpack_public_path__ + "static/media/email_btn.22f7d1bf6d5cf6ccf9404613aedc1b8c.svg";
export { ForwardRef as ReactComponent };